import React from "react";
import { ToolTip, SmartTooltip } from "../../../../components";

const TooltipExamples = () => {
  const colors = ["primary", "warning", "success", "danger", "black", "white"];
  const variants = ["contained", "outlined", "text"];
  const sizes = ["xs", "xs-sm", "sm", "md", "lg", "xl"];
  const positions = ["top", "bottom", "left", "right"];
  const noicon = [true, false];

  const ComplexContent = () => (
    <div className="space-y-2 text-sm">
      <h5 className="font-bold">Complex Tooltip</h5>
      <p>This is a multi-line tooltip with rich content.</p>
      <ul className="list-disc pl-4">
        <li>Feature 1</li>
        <li>Feature 2</li>
      </ul>
    </div>
  );

  return (
    <div className="p-8 space-y-12 overflow-auto flex flex-col flex-1">
      <section>
        <h2 className="text-xl font-bold mb-4">Tooltip Variants</h2>
        <div className="flex flex-col gap-8">
          {colors.map((color) => (
            <div className="flex gap-8">
              {variants.map((variant) => (
                <SmartTooltip
                  key={color}
                  description={`${color} colored tooltip`}
                  color={color}
                  variant={variant}
                  size="xs-sm"
                >
                  <span>
                    {color}-{variant}
                  </span>
                </SmartTooltip>
              ))}
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-bold mb-4">Tooltip Sizes</h2>
        <div className="flex gap-8">
          {sizes.map((size) => (
            <SmartTooltip
              key={size}
              description={`Size ${size} tooltip`}
              size={size}
              color="black"
            >
              <span className="">{size}</span>
            </SmartTooltip>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-bold mb-4">Tooltip Positions</h2>
        <div className="flex gap-8 items-center justify-center">
          {positions.map((position) => (
            <SmartTooltip
              key={position}
              description={`${position} positioned tooltip`}
              tooltipPosition={position}
            >
              <span className="font-medium">{position}</span>
            </SmartTooltip>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-xl font-bold mb-4">Complex Content Tooltip</h2>
        <div className="flex gap-8">
          <SmartTooltip description={<ComplexContent />} tooltipPosition="top">
            <span className="font-medium">Hover for complex content</span>
          </SmartTooltip>
          <SmartTooltip
            description={<ComplexContent />}
            tooltipPosition="right"
          >
            <span className="font-medium">Hover for complex content</span>
          </SmartTooltip>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-bold mb-4">Delayed Tooltip</h2>
        <div className="flex gap-8">
          <SmartTooltip
            description="This tooltip appears after 1 second"
            delay={1000}
            color="warning"
          >
            <span className="font-medium">Delayed tooltip</span>
          </SmartTooltip>
        </div>
      </section>
    </div>
  );
};

export default TooltipExamples;
